module.exports = __webpack_public_path__ + "img/forbidden.dad84bf0.png";